(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["advice-article"] && !Shopify.designMode) return;
  try {
    
  class ArticleToc extends HTMLElement {
    connectedCallback() {
      const source = document.getElementById(this.dataset.source);
      const list = this.querySelector('[data-toc-list]');
      if (!source || !list) return;
      const headings = [...source.querySelectorAll('h2, h3')].filter((heading) => heading.textContent.trim());
      if (headings.length < 2) return;
      list.replaceChildren();
      headings.forEach((heading, index) => {
        if (!heading.id) {
          const base = heading.textContent.trim().toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '') || `sectie-${index + 1}`;
          let id = base;
          for (let n = 2; document.getElementById(id); n += 1) id = `${base}-${n}`;
          heading.id = id;
        }
        heading.classList.add('scroll-mt-[calc(var(--header-h,4.5rem)+1.5rem)]');
        const item = document.createElement('li');
        if (heading.tagName === 'H3') item.className = 'pl-4';
        const link = document.createElement('a');
        link.href = `#${heading.id}`;
        link.textContent = heading.textContent.trim();
        link.className = 'flex min-h-11 items-center rounded-lg px-2 text-body-sm text-muted no-underline transition-colors hover:bg-canvas hover:text-primary';
        item.append(link);
        list.append(item);
      });
      this.hidden = false;
      if (window.matchMedia('(min-width: 1024px)').matches) this.querySelector('details')?.setAttribute('open', '');
    }
  }
  if (!customElements.get('article-toc')) customElements.define('article-toc', ArticleToc);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["quote-form"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const prefill = () => {
      const params = new URLSearchParams(window.location.search);
      document.querySelectorAll('[data-prefill-param]').forEach((input) => {
        const value = params.get(input.dataset.prefillParam);
        if (value && !input.value) input.value = value.trim().slice(0, 200);
      });
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', prefill);
    else prefill();
  })();

  } catch(e) { console.error(e); }
})();
})();
